import { render } from "./LoadingScreen.vue?vue&type=template&id=f19f11c2&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=f19f11c2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f19f11c2"

export default script